import type { SnackbarOrigin } from "notistack";
import type { AnyAction } from "redux";

export const notify = (
  text: string,
  variant: string,
  autoHideDuration?: number,
  anchorOrigin?: SnackbarOrigin
): AnyAction => ({
  type: "ENQUEUE_SNACK",
  payload: {
    key: crypto.getRandomValues(new Uint32Array(1))[0],
    message: text,
    options: { variant, autoHideDuration, anchorOrigin },
  },
});

export const notifySuccess = (text: string, autoHideDuration?: number, anchorOrigin?: SnackbarOrigin): AnyAction =>
  notify(text, "success", autoHideDuration, anchorOrigin);
export const notifyError = (text: string, autoHideDuration?: number, anchorOrigin?: SnackbarOrigin): AnyAction =>
  notify(text, "error", autoHideDuration, anchorOrigin);
export const notifyWarning = (text: string, autoHideDuration?: number, anchorOrigin?: SnackbarOrigin): AnyAction =>
  notify(text, "warning", autoHideDuration, anchorOrigin);
export const notifyInfo = (text: string, autoHideDuration?: number, anchorOrigin?: SnackbarOrigin): AnyAction =>
  notify(text, "info", autoHideDuration, anchorOrigin);
